/**
 * Выбирает множественную форму русского языка в зависимости от переданного числа `amount`.
 *
 * @param amount целое число
 * @param variants варианты, например ['экскурсия', 'экскурсии', 'экскурсий']
 */
export const choosePlural = (amount: number, variants: readonly [string, string, string]): string => {
  const _variants = variants;
  let _amount = amount;

  if (!amount) {
    _amount = 0;
  }

  const floored = Math.floor(_amount);

  if (_amount !== floored) {
    return floored === 1 ? _variants[1] : choosePlural(floored, _variants);
  }

  if (_amount % 10 === 1 && _amount % 100 !== 11) {
    return _variants[0];
  }

  if (_amount % 10 >= 2 && _amount % 10 <= 4 && (_amount % 100 < 10 || _amount % 100 >= 20)) {
    return _variants[1];
  }

  return _variants[2];
};

/**
 * Возвращает строку Число + множественная форма (1 экскурсия, 2 экскурсии, 10 экскурсий).
 *
 * @param amount целое число
 * @param variants варианты, например ['экскурсия', 'экскурсии', 'экскурсий']
 */

export const pluralize = (amount: number, variants: readonly [string, string, string]) =>
  Number.isNaN(amount) ? '' : choosePlural(amount, variants);
